import { ProgressBarSettings } from './types';

export const progressBarSettings: ProgressBarSettings = {
  componentVariants: {
    size: {
      prop: 'size',
      variants: {
        regular: {
          borderRadius: 4,
          height: 2,
        },
      },
    },
    color: {
      prop: 'color',
      variants: {
        success: {
          backgroundColor: 'success.main',
        },
        danger: {
          backgroundColor: 'danger.light',
        },
      },
    },
    mode: {
      prop: 'mode',
      variants: {
        dark: {
          backgroundColor: 'white.main',
        },
        light: {
          backgroundColor: 'gray.extraLight',
        },
      },
    },
  },
};
